import axios from "axios";
// import "./interceptors";
const API_URL = {
  dev: {
    SERVER_URL: "/testapi",
    AUTH_API: "/testAuthapi",
    QUESTION_BANK_API: "/testTikuapi",
    EXAM_URL_ACC: "//examweb-test.lingjiang.com", // 会计类作答页面域名
    EXAM_URL_ECO: "//examjjsweb-test.lingjiang.com", // 经济类作答页面域名
    OFFICIAL_URL: '//official-test.lingjiang.com',
    STUDY_CENTER_URL: "//official-test.lingjiang.com/learning/#/index/course",
    STUDY_REVIEW_URL: "//official-test.lingjiang.com/learning/#/im/chat",
    STUDY_PERSON_URL:
      "//official-test.lingjiang.com/learning/#/personal/account",
  },
  testDev: {
    SERVER_URL: "/testapi",
    AUTH_API: "/testAuthapi",
    QUESTION_BANK_API: "/testTikuapi",
    EXAM_URL_ACC: "//examweb-test.lingjiang.com",
    EXAM_URL_ECO: "//examjjsweb-test.lingjiang.com",
    OFFICIAL_URL: '//official-test.lingjiang.com',
    STUDY_CENTER_URL: "//official-test.lingjiang.com/learning/#/index/course",
    STUDY_REVIEW_URL: "//official-test.lingjiang.com/learning/#/im/chat",
    STUDY_PERSON_URL:
      "//official-test.lingjiang.com/learning/#/personal/account",
  },
  test: {
    SERVER_URL: "//mis1-test.lingjiang.com/",
    AUTH_API: "//authapi-test.lingjiang.com",
    QUESTION_BANK_API: "//examapi-test.lingjiang.com",
    EXAM_URL_ACC: "//examweb-test.lingjiang.com",
    EXAM_URL_ECO: "//examjjsweb-test.lingjiang.com",
    OFFICIAL_URL: '//official-test.lingjiang.com',
    STUDY_CENTER_URL: "//official-test.lingjiang.com/learning/#/index/course",
    STUDY_REVIEW_URL: "//official-test.lingjiang.com/learning/#/im/chat",
    STUDY_PERSON_URL:
      "//official-test.lingjiang.com/learning/#/personal/account",
  },
  prod: {
    SERVER_URL: "//mis1.lingjiang.com/",
    AUTH_API: "//authapi.lingjiang.com",
    QUESTION_BANK_API: "//examapi.lingjiang.com",
    EXAM_URL_ACC: "//examweb.lingjiang.com",
    EXAM_URL_ECO: "//examjjsweb.lingjiang.com",
    OFFICIAL_URL: '//www.lingjiang.com',
    STUDY_CENTER_URL: "//www.lingjiang.com/learning/#/index/course",
    STUDY_REVIEW_URL: "//www.lingjiang.com/learning/#/im/chat",
    STUDY_PERSON_URL: "//www.lingjiang.com/learning/#/personal/account",
  },
};

const isIp =
  /((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}/.test(
    window.location.hostname
  );
const arrHostname = window.location.hostname.split(".");
// cookie域名截取一级域名
export const COOKIE_DOMAIN = isIp
  ? window.location.hostname
  : (arrHostname.length > 2
      ? arrHostname.slice(arrHostname.length - 2)
      : arrHostname
    ).join(".");
export const _ENV =
  location.origin.includes("localhost") || location.origin.includes("172.")
    ? "dev"
    : location.origin.includes("dev")
    ? "testDev"
    : location.origin.includes("test")
    ? "test"
    : "prod";
const SERVER_URL = API_URL[_ENV]["SERVER_URL"];
const AUTH_API = API_URL[_ENV]["AUTH_API"];
const QUESTION_BANK_API = API_URL[_ENV]["QUESTION_BANK_API"];
// 会计类作答页面域名
export const EXAM_URL_ACC = API_URL[_ENV]["EXAM_URL_ACC"];
// 经济类作答页面域名
export const EXAM_URL_ECO = API_URL[_ENV]["EXAM_URL_ECO"];
// 官网地址
export const OFFICIAL_URL = API_URL[_ENV]["OFFICIAL_URL"];
// 学习中心地址
export const STUDY_CENTER_URL = API_URL[_ENV]["STUDY_CENTER_URL"];
// 评审服务地址
export const STUDY_REVIEW_URL = API_URL[_ENV]["STUDY_REVIEW_URL"];
// 个人中心地址
export const STUDY_PERSON_URL = API_URL[_ENV]["STUDY_PERSON_URL"];
            
// 根据项目获取页面数据
export async function getPageData(projectId) {
  const res = await axios.get(QUESTION_BANK_API + "/api/free-mock-exam/plans?project=" + projectId);
  return res;
}

// 获取项目
export async function getProjectList() {
  const res = await axios.get(SERVER_URL + "/api/projects/bycode?code=unite-mock-exam");
  return res;
}

// 获取数据 获取用户信息
export async function getUserInfo(token) {
  const res = await axios.get(AUTH_API + `/v1/student`, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return res;
}
// 获取题库用户信息（userId）
export async function getQuestionBankUserInfo(token) {
  const res = await axios.get(QUESTION_BANK_API + "/api/student", { headers: {'Authorization': "Bearer " + token}});
  return res;
}
// 获取手机验证码
export async function getChecknum(params) {
  const res = await axios.post(AUTH_API + `/v1/sms`, params);
  return res;
}
// 验证码登录
export async function phoneCodeLogin(parm) {
  const res = await axios.post(AUTH_API + `/v1/student/sign-in/phone`,parm );
  return res;
}
// 账号密码登录
export async function passwordLogin(parm) {
  const res = await axios.post(AUTH_API + `/v1/student/sign-in`, parm);
  return res;
}
// 账号密码登录 上报推广方案
export async function uploadRegistrEvent(params) {
  const res = await axios.post(SERVER_URL + `/api/registration/save`, params);
  return res;
}

// 获取模考场次列表
export async function getScenesList(code) {
  const res = await axios.get(SERVER_URL + `/api/paperconfigs/${code}`);
  return res;
}

// 模考预约
export async function modeltestAppointment(sceneId) {
  const res = await axios.post(QUESTION_BANK_API + `/api/free-mock-exam/${sceneId}/order`, {} , { headers: {'Authorization': "Bearer " + Cookies.get("token") || ''}});
  return res;
}

// 查询预约状态
export async function getAppointmentStatus(sceneId) {
  const res = await axios.get(QUESTION_BANK_API + `/api/free-mock-exam/${sceneId}/status`, { headers: {'Authorization': "Bearer " + Cookies.get("token") || ''}});
  return res;
}

// 获取examId
export async function getExamId(papersId, userId, access_token) {
  const res = await axios.post(QUESTION_BANK_API + `/api/user/exam/record`, {'paperId': papersId, 'UserId': userId, "dataSource": 1 },{ headers: { "Authorization": "Bearer " + access_token }});
  return res;
}

// 获取学员试卷状态
export async function getStudentExamStatus(papersId) {
  const res = await axios.get(QUESTION_BANK_API + `/api/exam/exam-status?papersId=${papersId}`, { headers: {'Authorization': "Bearer " + Cookies.get("token") || ''}});
  return res;
}

// 获取未交卷的考试信息
export async function getStudentUncommittedExamId(papersId) {
  const res = await axios.get(QUESTION_BANK_API + `/api/exam/uncommitted-exam?papersId=${papersId}`, { headers: {'Authorization': "Bearer " + Cookies.get("token") || ''}});
  return res;
}

// 获取学员考试examid
export async function getStudentExamId(papersId) {
  const res = await axios.get(QUESTION_BANK_API + `/api/exam/exam-id?papersId=${papersId}`, { headers: {'Authorization': "Bearer " + Cookies.get("token") || ''}});
  return res;
}










// WEBPACK FOOTER //
// ./src/api/api.js